<template>
  <div
    class="nav-menu noselect"
    :class="{ 'nav-menu--inset': !root }"
    :style="{ height: root ? `${viewportHeight}px` : null }"
  >
    <div
      class="nav-menu__menu-container"
      :class="{ 'nav-menu__menu-container--active': active }"
      ref="menu"
    >
      <div
        class="nav-menu__menu-background"
        :class="{ 'nav-menu__menu-background--active': active }"
        @click="() => handleActiveControl(false)"
      ></div>
      <template v-if="GET_IS_ABOVE_BREAKPOINT('lg')">
        <NavigationMenuDesktop
          :active="active"
          @activated="handleActiveControl"
          :root="root"
          :uiColor="uiColor"
        />
      </template>
      <template v-else>
        <NavigationMenuMobile
          v-if="root"
          :active="active"
          :root="root"
          :uiColor="uiColor"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"

import NavigationMenuDesktop from "./NavigationMenuDesktop.vue"
import NavigationMenuMobile from "./NavigationMenuMobile.vue"

export default {
  props: {
    active: Boolean,
    root: Boolean,
    uiColor: String
  },

  components: {
    NavigationMenuDesktop,
    NavigationMenuMobile
  },

  methods: {
    ...mapMutations("ui", ["SET_ROUTE_TRANSITION_STATE"]),
    ...mapActions("identity", ["SIGN_OUT"]),

    handleActiveControl(val) {
      this.$emit("activated", val)
    }
  },

  computed: {
    ...mapState("ui", ["routeTransitionState"]),
    ...mapGetters("breakpoints", [
      "GET_IS_BELOW_BREAKPOINT",
      "GET_IS_ABOVE_BREAKPOINT"
    ]),
    ...mapState("scroll", ["viewportHeight"]),
    ...mapState("identity", ["authJWT"])
  },

  watch: {
    routeTransitionState(val) {
      if (val) {
        this.$emit("activated", false)
      }
    }
  }
}
</script>

<style lang="scss">
.nav-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;

  &--inset {
    height: $nav-height-default;

    @include media-breakpoint-up(md) {
      height: $nav-height-md;
    }

    @include media-breakpoint-up(lg) {
      height: $nav-height-lg;
    }

    @include media-breakpoint-up(xl) {
      height: $nav-height-xl;
    }

    .show-banner.active-banner & {
      height: $nav-height-default - $banner-height-default;

      @include media-breakpoint-up(sm) {
        height: $nav-height-default - $banner-height-sm;
      }

      @include media-breakpoint-up(md) {
        height: $nav-height-md - $banner-height-sm;
      }

      @include media-breakpoint-up(lg) {
        height: $nav-height-lg - $banner-height-lg;
      }

      @include media-breakpoint-up(xl) {
        height: $nav-height-xl - $banner-height-lg;
      }
    }
  }

  &__menu-container {
    position: absolute;
    top: $nav-height-default;
    left: 0;
    width: 100%;
    height: calc(100% - #{$nav-height-default});
    transition: all $banner-animation-speed $banner-animation-ease;
    transition-property: transform;
    will-change: height;

    @include media-breakpoint-up(md) {
      top: $nav-height-md;
      height: calc(100% - #{$nav-height-md});
    }

    @include media-breakpoint-up(lg) {
      top: $nav-height-lg;
      height: calc(100% - #{$nav-height-lg});
    }

    @include media-breakpoint-up(xl) {
      top: $nav-height-xl;
      height: calc(100% - #{$nav-height-xl});
    }

    .show-banner.active-banner & {
      transform: translateY($banner-height-default);
      height: calc(100% - #{$nav-height-default});

      @include media-breakpoint-up(sm) {
        transform: translateY($banner-height-sm);
        height: calc(100% - (#{$nav-height-default} + #{$banner-height-sm}));
      }

      @include media-breakpoint-up(md) {
        transform: translateY($banner-height-sm);
        height: calc(100% - (#{$nav-height-md} + #{$banner-height-sm}));
      }

      @include media-breakpoint-up(lg) {
        transform: translateY($banner-height-lg);
        height: calc(100% - (#{$nav-height-lg} + #{$banner-height-lg}));
      }

      @include media-breakpoint-up(xl) {
        transform: translateY($banner-height-lg);
        height: calc(100% - (#{$nav-height-xl} + #{$banner-height-lg}));
      }
    }
  }

  &__menu-background {
    background-color: rgba($bleach-black, 0.5);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s linear 0.2s;
    backdrop-filter: saturate(20%) contrast(80%);

    @include media-breakpoint-up(lg) {
      top: $menu-height-lg;
    }

    &--active {
      transition: opacity 0.2s;
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>
